import { createBrowserRouter } from "react-router-dom";
import { installAppLinkNavigation } from "src/lib/runtime/appLinks";
import Routes from "./routes";

const App = createBrowserRouter(Routes);

installAppLinkNavigation((path) => App.navigate(path));

export default App;
